import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes,Route } from 'react-router-dom';
import Connexion from './Pages/Connexion/Connexion';
import Dashboard from './Pages/Dashboard/Dashboard';
import DashboardProvider from './Hooks/DashboardContext';
import AddProduct from './Pages/Dashboard/AddProduct/AddProduct';
import Home from './Pages/Dashboard/Home/Home';
import Products from './Pages/Dashboard/Products/Products';
import Purchases from './Pages/Dashboard/Purchases/Purchases';
import Customers from './Pages/Dashboard/Customers/Customers';
import Analytics from './Pages/Dashboard/Analytics/Analytics';
import Settings from './Pages/Dashboard/Settings/Settings';
import Loading from './components/Loading/Loading';
import ProductsMenu from './Pages/Dashboard/ProductsMenu/ProductsMenu';
import Banners from './Pages/Dashboard/ProductsMenu/Banners/Banners';
import TopUnes from './Pages/Dashboard/ProductsMenu/TopUnes/TopUnes';

function App() {
 

  return (
    <DashboardProvider>
      <Loading/>
      <div className='Consigne'>
          Ouvrez l'app sur un ecran au minimum large de 1400px
      </div>
      <div id="App" className="App">
        
        
        <Router>

          <Routes>

            <Route path='*' element={<Connexion/>}/>
            <Route path='/Connexion' element={<Connexion/>}/>

            <Route path='/Dashboard' element={<Dashboard/>}>

              <Route path='/Dashboard' element={<div className='FadeIn'>Ornoir Market</div>}/>

              <Route path='Home' element={<Home/>}/> 
              
              <Route path='ProductsMenu' element={<ProductsMenu/>}/>  
              <Route path='ProductsMenu/Products' element={<Products/>}/> 
              <Route path='ProductsMenu/Banners' element={<Banners/>}/>  
              <Route path='ProductsMenu/TopUne' element={<TopUnes/>}/>  

              <Route path='Purchases' element={<Purchases/>}/>                     
              <Route path='Customers' element={<Customers/>}/>                         
              <Route path='Analytics' element={<Analytics/>}/>                         
              <Route path='Settings' element={<Settings/>}/> 

              <Route path='ProductsMenu/AddProduct' element={<AddProduct/>}/> 

            </Route>
            
          </Routes>
      
        </Router>
      
      </div>
    </DashboardProvider>
  );
}

export default App;
